angular.module('impactx.navigation').controller('PartialDialogsDialogCtrl', PartialDialogsDialogCtrl);

PartialDialogsDialogCtrl.$inject = ['$scope', 'dataGen', '$mdDialog', 'type', 'doneDialogs'];

function PartialDialogsDialogCtrl($scope, dataGen, $mdDialog, type, doneDialogs) {

    var ctrl = this;
    $scope.type = type;
    $scope.doneDialogs = doneDialogs;

    ctrl.getData = function () {
        dataGen.getData($scope, {type: $scope.type}, '/navigation/partialdialogs');
    }

    ctrl.onClick = function (path) {
        $mdDialog.hide(path);
    }

    ctrl.getData();
}